import { Header } from "./Header";
import { Footer } from "./Footer";

/**
 * Default site layout component
 */
export const Layout = ({ wrapperClass, menuDoc, children, footerDoc }) => {
  return (
    <div className={wrapperClass}>
      <Header menuDoc={menuDoc} />
      {children}
      <Footer footerDoc={footerDoc} />
    </div>
  );
};
